import { useEffect } from 'react';

export default value =>
  useEffect(() => {
    const modals = document.querySelectorAll('.modals');
    const secondModal = modals && modals[1];
    if (secondModal) secondModal.classList.add('centeredModal');
  }, [value]);
